import Modal from "react-modal";
import { useState } from "react";
import EyeDetailsIcon from "../Svgs/EyeDetailsIcon";

Modal.setAppElement("#root");

const ViewLessonModal = ({ videoUrl }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <button onClick={openModal} className="!tw-m-0">
        <EyeDetailsIcon width={35} />
      </button>

      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Video Modal"
        className="tw-w-full tw-max-w-3xl tw-bg-white tw-rounded-xl tw-p-2 tw-mx-auto tw-outline-none"
        overlayClassName="tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-items-center tw-justify-center tw-z-50"
      >
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-2">
          <h2 className="tw-text-lg tw-font-bold">Lesson Video</h2>
          <button
            onClick={closeModal}
            className="!tw-m-0 !tw-p-0 tw-text-red-500"
          >
            <span className="material-icons">cancel</span>
          </button>
        </div>

        <div className="tw-w-full tw-aspect-video">
          <iframe
            src={videoUrl}
            title="Video"
            allowFullScreen
            frameBorder="0"
            className="tw-w-full tw-h-full tw-rounded"
          />
        </div>
      </Modal>
    </>
  );
};

export default ViewLessonModal;
